import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { ICategoryContext, CategoryContext } from '../../../../../categoryState/categoryContext';
import style from './DropdownMenu.module.scss';

export const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<ICategoryContext>(CategoryContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByCategoryLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByCategoryA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('CategoriesA-Z')}
						checked={sortBy === 'CategoriesA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByCategoryZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('CategoriesZ-A')}
						checked={sortBy === 'CategoriesZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByCategoryTypeLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByCategoryTypeA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('CategoryTypeA-Z')}
						checked={sortBy === 'CategoryTypeA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByCategoryTypeZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('CategoryTypeZ-A')}
						checked={sortBy === 'CategoryTypeZ-A'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};
